/**
 * searches selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

interface State {
    searches: {
        [string]: string
    };
}

interface Props {
    namespace: string;
}

const selectSearches = (state: State) => state.searches;
const selectNamespace = (state: State, props: Props) => props.namespace;

const makeSelectSearch = () =>
    createDeepEqualSelector(
        [selectSearches, selectNamespace],
        (searchesState, namespaceState) => searchesState[namespaceState]
    );

export { makeSelectSearch };
